import { get } from 'lodash';

import type { YardTaskTimelineEvent } from './types';

export type FlagAction = 'added' | 'removed';

export interface FlagInfo {
  type: string | null;
  action: FlagAction | null;
}

export function getAddedFlags(event: YardTaskTimelineEvent): string[] {
  const addedFlags = get(event, 'data.data.addedFlags');

  if (Array.isArray(addedFlags)) {
    return addedFlags;
  }

  return [];
}

export function getRemovedFlags(event: YardTaskTimelineEvent): string[] {
  const removedFlags = get(event, 'data.data.removedFlags');

  if (Array.isArray(removedFlags)) {
    return removedFlags;
  }

  return [];
}

/**
 * Determines the flag type and action from a flagged event
 * @param {YardTaskTimelineEvent} event - The flagged event
 * @returns {FlagInfo} Object containing the flag type and action
 */
export function getFlagInfo(event: YardTaskTimelineEvent): FlagInfo {
  const addedFlags = getAddedFlags(event);
  const removedFlags = getRemovedFlags(event);

  if (addedFlags.includes('issue')) {
    return { type: 'issue', action: 'added' };
  }
  if (removedFlags.includes('issue')) {
    return { type: 'issue', action: 'removed' };
  }

  if (addedFlags.includes('urgent')) {
    return { type: 'urgent', action: 'added' };
  }
  if (removedFlags.includes('urgent')) {
    return { type: 'urgent', action: 'removed' };
  }

  if (addedFlags.length > 0) {
    return { type: addedFlags[0], action: 'added' };
  }

  if (removedFlags.length > 0) {
    return { type: removedFlags[0], action: 'removed' };
  }

  return { type: null, action: null };
}
